import {useEffect, useState, type FormEvent} from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import {useTranslation} from "react-i18next";
import {Alert, FloatingLabel} from "react-bootstrap";
import {changePassword} from "../../../util/SecurityUtils";
import {useNavigate} from "react-router-dom";

interface ChangePasswordModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

function ChangePasswordModal(props: ChangePasswordModalProps) {
    const { t } = useTranslation();
    const [ user, setUser ] = useState({currentPassword: "", password: "", confirmPassword: ""})
    const [ isLoading , setIsLoading ] = useState(false);
    const [ somethingWentWrong, setSomethingWentWrong ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (props.isOpen === false) {
            setUser({currentPassword: "", password: "", confirmPassword: ""})
            setSomethingWentWrong(false)
            setIsLoading(false)
        }
    }, [props.isOpen]);

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setIsLoading(true)
        changePasswordAndClose(user.currentPassword, user.confirmPassword)
    };

    const changePasswordAndClose = (currentPassword: string, newPassword: string) => {
        changePassword(currentPassword, newPassword).then((success) => {
            props.closeModal()
            if (success) {
                navigate(0)
            }
        }).catch(() => {
            setSomethingWentWrong(true)
            setIsLoading(false)
        })
    }

    const isSubmitButtonDisabled = () => {
        if (isLoading) {
            return true;
        }
        return !user.currentPassword || !user.password || !user.confirmPassword || user.password !== user.confirmPassword;
    }

    return (
      <Modal
        show={props.isOpen}
        onHide={props.closeModal}
      >
          <Modal.Header closeButton>
              <Modal.Title>{t("changePassword")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <Form noValidate onSubmit={handleSubmit}>
                  <Form.Group>
                      <FloatingLabel
                        controlId="currentPassword"
                        label={t("currentPassword")}
                        className="mb-3"
                      >
                          <Form.Control required type="password" onChange={e => setUser({...user, currentPassword: e.target.value})} value={user.currentPassword} placeholder=""/>
                      </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                      <FloatingLabel
                        controlId="floatingPassword"
                        label={t("password")}
                        className="mb-3"
                      >
                          <Form.Control required type="password" onChange={e => setUser({...user, password: e.target.value})} value={user.password} placeholder=""/>
                      </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                      <FloatingLabel
                        controlId="floatingPasswordConfirmation"
                        label={t("confirmPassword")}
                        className="mb-3"
                      >
                          <Form.Control required type="password" onChange={e => setUser({...user, confirmPassword: e.target.value})} value={user.confirmPassword} placeholder=""/>
                      </FloatingLabel>
                  </Form.Group>
                  { user.confirmPassword && user.password !== user.confirmPassword ? <div className="loss mb-3">{t("passwordDoesNotMatch")}</div> : null}
                  { somethingWentWrong ?
                    <Alert variant="danger">
                        {t("wrongPassword")}
                    </Alert> : null }
                  <div className="d-flex">
                      <Button type="submit" disabled={isSubmitButtonDisabled()}>{t("changePassword")}</Button>
                  </div>
              </Form>
          </Modal.Body>
      </Modal>
    );
}

export default ChangePasswordModal;
